import { CheckBoxListControlValueItem } from "./check-box-list-control-value-item.model";
import { isArray } from "ionic-angular/util/util";

export class CheckBoxListControlValue {

    protected items: Array<CheckBoxListControlValueItem> = [];

    constructor(raw?: any | Array<any>) {

        if (!raw) {
            return;
        }

        if (isArray(raw.items)) {
            raw = raw.items;
        }

        if (isArray(raw)) {
            try {
                this.items = raw.map(item => new CheckBoxListControlValueItem(item));
            } catch (e) {
                console.warn("value has invalid format", raw);
            }
        }
    }

    getItems(): Array<CheckBoxListControlValueItem> {
        return this.items;
    }

    has(value: string): boolean {
        return !!this.items.find(item => item.getId() === value);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/form/check-box-list-control-value.model.ts